import { useEffect, useId, useRef, useState } from "react";

// Випадне меню шапки: кнопка + список пунктів. Закривається кліком поза меню та Escape,
// стрілки ↑/↓, Home/End переходять між пунктами, фокус повертається на кнопку.
export default function Menu({ label, button, className = "", align = "end", children }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null), btn = useRef(null), list = useRef(null);
  const id = useId();
  const items = () => [...(list.current?.querySelectorAll('[role^="menuitem"]:not([aria-disabled="true"])') || [])];
  const close = (focus = true) => { setOpen(false); if (focus) btn.current?.focus(); };

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => (items().find((x) => x.getAttribute("aria-checked") === "true") || items()[0])?.focus(), 0);
    const outside = (e) => { if (!root.current?.contains(e.target)) close(false); };
    document.addEventListener("pointerdown", outside);
    return () => { clearTimeout(t); document.removeEventListener("pointerdown", outside); };
  }, [open]);

  const onKey = (e) => {
    const all = items(), i = all.indexOf(document.activeElement);
    const go = { ArrowDown: i + 1, ArrowUp: i - 1, Home: 0, End: all.length - 1 }[e.key];
    if (go !== undefined) { e.preventDefault(); all[(go + all.length) % all.length]?.focus(); }
    else if (e.key === "Escape") { e.preventDefault(); close(); }
    else if (e.key === "Tab") close(false);
  };

  return (
    <div className={`menu ${className}`} ref={root}>
      <button ref={btn} type="button" className="menu-button" aria-haspopup="menu" aria-expanded={open} aria-controls={id}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => { if (e.key === "ArrowDown") { e.preventDefault(); setOpen(true); } }}>
        {/* Назва кнопки = призначення + видимий текст (WCAG 2.5.3: видимий текст має входити в доступну назву) */}
        <span className="sr-only">{label}: </span>{button}
      </button>
      {open && (
        <div ref={list} id={id} role="menu" aria-label={label} className={`menu-list menu-${align}`} onKeyDown={onKey}
          onClick={(e) => { if (e.target.closest('[role="menuitem"], a[role="menuitemradio"]')) close(false); }}>
          {children}
        </div>
      )}
    </div>
  );
}

export const Chevron = () => (
  <svg className="chev" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m4 6 4 4 4-4" /></svg>
);
export const Check = () => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m3.5 8.5 3 3 6-7" /></svg>
);
